import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';


// Import the language JSON files
import enTranslation from './locales/en/translations.json';
import frTranslation from './locales/fr/translations.json';

i18next.use(initReactI18next).init({
    resources: {
        en: {
            translation: enTranslation,
        },
        fr: {
            translation: frTranslation,
        },
    },
    lng: 'en', // Default language
    fallbackLng: 'en', // If the selected language is not available, fallback to English
    interpolation: {
        escapeValue: false, // React already escapes the values
    },

});
// console.log(i18next); // Check i18next instance


export default i18next;
